import { isUndefined, omitBy } from 'lodash';
import { get, httpDelete, patch, post } from '../../utils/http';

export const addLocation = ({ accountId, branchId, location: { location, ...rest } }) =>
  post(`/accounts/${accountId}/branches/${branchId}/locations`, { ...location, ...rest });

export const fetchBranchLocation = ({ accountId, branchId, locationId, withAttachments }) =>
  get(`/accounts/${accountId}/branches/${branchId}/locations/${locationId}`, { withAttachments });

export const updateLocation = ({
  accountId,
  branchId,
  locationId,
  //  { instructions, attachments  } are partially supported in backend, but not in UI
  location: { name, photo, lat, lng, address, subLocations }
}) =>
  patch(
    `/accounts/${accountId}/branches/${branchId}/locations/${locationId}`,
    omitBy({ name, lat, lng, address, photo, subLocations }, isUndefined)
  );

export const addSubLocation = ({ accountId, branchId, subLocationId, locationId, clientBranchId }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/locations/${locationId}/sub-locations`, {
    subLocationId,
    clientBranchId
  });

export const deleteLocation = ({ accountId, branchId, locationId }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/locations/${locationId}`);
